import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "skeleton" }
const _hoisted_2 = {
  key: 0,
  class: "skeleton__header"
}
const _hoisted_3 = {
  key: 1,
  class: "skeleton__footer"
}

import { ElSkeletonItem } from 'element-plus';

interface Props {
  withHeader?: boolean;
  withFooter?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardSkeleton',
  props: {
    withHeader: { type: Boolean, default: false },
    withFooter: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.withHeader)
      ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
          _createVNode(_unref(ElSkeletonItem), { class: "skeleton__header__sup" }),
          _createVNode(_unref(ElSkeletonItem), { class: "skeleton__header__sub" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["skeleton__content", {
        skeleton__content__picture: !Boolean(_ctx.withHeader && _ctx.withFooter),
      }])
    }, [
      _createElementVNode("img", {
        src: "/img/empty/skeleton.png",
        class: _normalizeClass([
          Boolean(_ctx.withHeader && _ctx.withFooter) ? 'max-content' : 'min-content',
        ]),
        alt: "skeleton-card"
      }, null, 2)
    ], 2),
    (_ctx.withFooter)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_3, [
          _createVNode(_unref(ElSkeletonItem), { class: "skeleton__footer__sup" }),
          _createVNode(_unref(ElSkeletonItem), { class: "skeleton__footer__sub" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})